__webpack_require__.p = "/grupper/D05-23/";